// src/pages/admin/ToggleSwitch.js
const cx = (...xs) => xs.filter(Boolean).join(" ");

function ToggleSwitch({ checked, onChange }) {
  return (
    <button
      type="button"
      onClick={onChange}
      className={cx(
        "relative inline-flex items-center h-6 w-11 rounded-full transition-colors border",
        checked
          ? "bg-emerald-500 border-emerald-500"
          : "bg-slate-200 border-slate-300"
      )}
    >
      <span
        className={cx(
          "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform",
          checked ? "translate-x-5" : "translate-x-1"
        )}
      />
    </button>
  );
}

export default ToggleSwitch;
